var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopout = function SvgPopout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 125"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M90.7 12.5v-.7l-.2-.4-.2-.3-.5-.6-.8-.6-.3-.2-.4-.2H65.1a4 4 0 1 0 0 8h12L41.2 53.1a4 4 0 1 0 5.7 5.7l35.9-35.9v12a4 4 0 0 0 8 0V13.2a4 4 0 0 0-.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M21.2 90.8h47.4a12 12 0 0 0 12-12V50.5a4 4 0 1 0-8 0v28.3a4 4 0 0 1-4 4H21.2a4 4 0 0 1-4-4V31.4a4 4 0 0 1 4-4h28.3a4 4 0 0 0 0-8H21.2a12 12 0 0 0-12 12v47.4a12 12 0 0 0 12 12Z"
  }))));
};
export default SvgPopout;